import { Preloader } from "@icg360/ui-toolkit";
import React, { Fragment, useState, useRef } from "react";
import PT from "prop-types";
import useFetch from "../../shared/hooks/use-fetch";
import { findAddress } from "./google-places";
var errorMessages = {
  ZERO_RESULTS: "There were no results.",
  OVER_QUERY_LIMIT: "Too many queries.",
  REQUEST_DENIED: "Query denied.",
  UNKNOWN_ERROR: "Could not send the query at this time.",
  ERROR: "Could not send the query."
};

var request = function request(using) {
  return findAddress(using).then(function (results) {
    return {
      results: results,
      usedAddress: using.address
    };
  });
};

AddressSearch.propTypes = {
  query: PT.string.isRequired,
  onAddress: PT.func.isRequired,
  render: PT.func,
  enableSearch: PT.bool
};
AddressSearch.defaultProps = {
  render: null,
  enableSearch: false
};
export default function AddressSearch(_ref) {
  var query = _ref.query,
      onAddress = _ref.onAddress,
      render = _ref.render;

  var _useState = useState(""),
      searchedQuery = _useState[0],
      setSearch = _useState[1];

  var container = useRef(null);

  var _useFetch = useFetch({
    request: request,
    using: {
      address: searchedQuery
    },
    skipCall: !searchedQuery
  }),
      _useFetch$ = _useFetch[0],
      _useFetch$$data = _useFetch$.data;

  _useFetch$$data = _useFetch$$data === void 0 ? {} : _useFetch$$data;
  var _useFetch$$data$resul = _useFetch$$data.results,
      results = _useFetch$$data$resul === void 0 ? [] : _useFetch$$data$resul,
      usedAddress = _useFetch$$data.usedAddress,
      dataMatchesRequest = _useFetch$.dataMatchesRequest,
      error = _useFetch$.error,
      status = _useFetch$.status;
  var filteredResults = results.filter(function (_ref2) {
    var state = _ref2.state;
    return state;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "AddressSearch",
    tabIndex: "-1",
    ref: container
  }, function () {
    if (status === (useFetch == null ? void 0 : useFetch.STATUSES.BUSY)) {
      return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Preloader, {
        size: "17"
      }), " ");
    }

    if (usedAddress !== query) {
      return /*#__PURE__*/React.createElement("p", {
        style: {
          marginLeft: "15px"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          setSearch(query); // This element is going to be removed and the dropdown will lose focus

          container.current.focus();
        }
      }, "Search \u201C", query, "\u201D"));
    }

    if (!filteredResults.length || status === (useFetch == null ? void 0 : useFetch.STATUSES.ERROR)) {
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: "10px"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Address not found.")), status === (useFetch == null ? void 0 : useFetch.STATUSES.ERROR) && errorMessages[error] && /*#__PURE__*/React.createElement("p", null, errorMessages[error]));
    }

    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: "10px"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Did you mean:")), /*#__PURE__*/React.createElement("ul", {
      style: {
        marginRight: "20px"
      }
    }, filteredResults.map(function (result) {
      return /*#__PURE__*/React.createElement("li", {
        key: result.placeId
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          onAddress(result);
        }
      }, result.display));
    })));
  }(), render && render(usedAddress === query ? {
    data: results,
    dataMatchesRequest: dataMatchesRequest,
    error: error,
    status: status
  } : {}));
}